import { type ICountdownIterator, type ICountdownItem } from "../types";

import {
    getSecondsLeft as oldProductGetSecondsLeft,
    setSecondsLeft as oldProductSetSecondsLeft,
} from "../../specs/old-product";

export class OldProductCountdownItem implements ICountdownItem {
    //shouldAppendToAuctionSocket: boolean = true;
    //auctionSocketId: any;
    timer: any;
    constructor({
        /* auctionSocketId, */ timer,
    }: {
        auctionSocketId: any;
        timer: any;
    }) {
        //this.auctionSocketId = auctionSocketId;
        this.timer = timer;
    }
    setInitialSeconds(initialSeconds: number): void {
        this.timer.data("initialSeconds", initialSeconds);
    }
    getInitialSeconds(): number {
        return this.timer.data("initialSeconds");
    }
    setInitializedDate(initializedDate: Date): void {
        this.timer.data("initializedDate", initializedDate);
    }
    getInitializedDate(): Date {
        return this.timer.data("initializedDate") as Date;
    }
    shouldShowTimeout(): boolean {
        return this.timer.attr("status") === "notStart";
    }
    textSetter(content: string): void {
        this.timer.html(content);
    }
    setSecondsLeft(value: number): void {
        oldProductSetSecondsLeft(this.timer, value);
    }
    getSecondsLeft(): number {
        return oldProductGetSecondsLeft(this.timer);
    }
}

function getParent(el: Element | null | undefined, className: string) {
    if (el == null) {
        return undefined;
    }
    if (el.classList.contains(className)) {
        return el;
    }
    return getParent(el.parentElement, className);
}

export class OldProductCountdownIterator implements ICountdownIterator {
    *getItems(): Generator<ICountdownItem, any, any> {
        const countdownItems = Array.from(
            document.querySelectorAll(".countdownTimer")
        );
        for (const timerElement of countdownItems) {
            const specsContainer = getParent(timerElement, "specsToUpdate");
            if (specsContainer == null) continue;
            const itemId = specsContainer.getAttribute("data-item-id");

            yield new OldProductCountdownItem({
                auctionSocketId: itemId,
                timer: $(timerElement),
            });
        }
    }
}
